import { DatetimeType } from '@watershed/lscript/expr_types';
import { Func, SqlExpression } from '../types';
import {
  dateFunctionTypecheck,
  dateFunctionToSql,
  dateFunctionEval,
} from './date';

export const datetime: Func = {
  typecheck(...args): DatetimeType {
    return dateFunctionTypecheck(
      { functionName: 'datetime', returnType: 'datetime' },
      ...args
    );
  },

  eval(...args): Date | null {
    return dateFunctionEval({ functionName: 'datetime' }, ...args);
  },

  toSql(...args): SqlExpression {
    return dateFunctionToSql(
      { functionName: 'datetime', duckdbType: 'TIMESTAMP' },
      ...args
    );
  },
};
